import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { FieldOrigin, LoanFieldProps } from 'config'
import { estimatedClosingAmountBorrower } from 'pages/LoanStructure/Logic'
import { store } from 'reducers'
import { isLoanFieldPropHidden } from 'utils/loan'

import { BorrowerSeperator } from '../config'
import { borrowerMenuKey } from '../util'
import { type IAssetData, AssetAccountTypeForPlaid } from './constants'

export const assetInfoValidate = (borrowerSeperator: BorrowerSeperator, updateStore = false) => {
  const {
    borrower,
    borrower: {
      [borrowerSeperator]: { assets },
    },
    loan,
    step,
    loanDetail,
    vendor,
    globalConfigReducer,
  } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  const rulesConfig = globalConfigReducer[GlobalConfigType.RulesConfig]
  if (((loanFieldProperties as any)['visibility'] || {})[FieldOrigin.AssetLiability] === false) return true

  const assetLiabilityProps = loanFieldProperties[FieldOrigin.AssetLiability]
  if (assetLiabilityProps?.assetInformation?.visibleLoanTypes?.[loanDetail.loanType] === false) return true
  if (isLoanFieldPropHidden(assetLiabilityProps?.assetInformation, loan)) return true

  const pageProps = loanFieldProperties.properties
  if (pageProps?.[FieldOrigin.AssetLiability]?.['visibleByBorrower']?.[borrowerSeperator] === false) return true

  const plaidConfig = vendor.Plaid
  const snapptConfig = vendor.Snappt

  let hasAnyVerifiedAsset = false
  Object.keys(borrower).map((key) => {
    if (!borrower[key].isIncluded) return
    const assets = borrower[key].assets || []
    const verifiedAssets = assets.filter((asset: IAssetData) => {
      if (
        AssetAccountTypeForPlaid.includes(asset.accountType || 0) &&
        (asset.verified || asset.override || (!plaidConfig && !snapptConfig))
      )
        return true
      return false
    })
    if (verifiedAssets.length) hasAnyVerifiedAsset = true
  })

  if (hasAnyVerifiedAsset && assets?.length == 0) return true

  let success =
    assets?.filter((asset: IAssetData) => {
      if (!AssetAccountTypeForPlaid.includes(asset.accountType || 0)) return false
      if (asset.verified || !rulesConfig.assetVerifyRequire || asset.override || (!plaidConfig && !snapptConfig))
        return false
      if (!asset.bankStatementFileKey) return true
      return !asset.bankStatementReportFileKey && !asset.bankStatementData.webhookReportData
    }).length == 0
  const { transactionType } = loan

  const verifiedAssets = assets?.filter(
    (asset: IAssetData) =>
      !AssetAccountTypeForPlaid.includes(asset.accountType || 0) ||
      asset.verified ||
      !rulesConfig.assetVerifyRequire ||
      asset.override ||
      (!plaidConfig && !snapptConfig),
  )
  if (transactionType == 'Purchase' && verifiedAssets?.length == 0) success = false
  else if (transactionType == 'Refinance' && assets?.length == 0) {
    const { value } = estimatedClosingAmountBorrower(loan, loanDetail.loanGlobalSettings)
    if (value < 0) success = false
  }

  if (updateStore) {
    let application = cloneDeep(step.application)
    const menuKey = borrowerMenuKey(borrowerSeperator, 'asset')
    application[menuKey] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }

  return success
}
